module.exports = __webpack_public_path__ + "media/assets/icons/bell-2-935bb5d3caa8bf2b9e90f9a35e7232a8.svg";